<template>
  <div class="pr-5 pl-5">
    <table class="table">
      <thead>
        <tr>
          <th>Hazard No.</th>
          <th>Created By</th>
          <!-- <th>Addressed To</th> -->
          <th>Date Created</th>
          <!-- <th>Update By</th> -->
          <!-- <th>Response Date</th> -->
          <!-- <th>Discipline</th> -->
          <!-- <th>Hazard Type</th> -->
          <th>Model View</th>
          <th>Status</th>

          <th>Type</th>
          <!-- <th>Priority</th> -->
          <!-- <th>Severity</th> -->
          <th>Risk Classification</th>
          <th>Attachments</th>
          <th>Actions</th>
          <th>Delete</th>
        </tr>
        <tr>
          <td></td>
          <td>
            <input type="text" v-model="searchCreatedBy" placeholder="Search" class="form-control form-control-sm">
            <!-- <div class="input-group mb-3">
              <input type="text" v-model="searchCreatedBy" class="form-control form-control-sm">
              <div class="input-group-append">
                <button class="btn btn-outline-secondary btn-sm" type="button"><i class="fa fa-search"></i></button>
              </div>
            </div> -->
          </td>
          <!-- <td> -->
            <!-- <input type="text" class="form-control form-control-sm" v-model="searchAddressedTo" placeholder="Search"> -->
            <!-- <div class="input-group mb-3">
              <input type="text" class="form-control form-control-sm">
              <div class="input-group-append">
                <button class="btn btn-outline-secondary btn-sm" type="button"><i class="fa fa-search"></i></button>
              </div>
            </div> -->
          <!-- </td> -->
          <td></td>
          <!-- <td></td> -->
          <!-- <td></td> -->
          <!-- <td>
            <select class="form-control form-control-sm" v-model="selectedDiscipline" required>
              <option value="All" selected>All</option>
              <option v-for="(item, index) in disciplineFilterSet" :value="item" :key="index">{{item}}</option>
            </select>
          </td> -->
          <td>
            <select class="form-control form-control-sm" v-model="selectedHazardType" required>
              <option value="All" selected>All</option>
              <option v-for="(item, index) in hazardTypeFilterSet" :value="item" :key="index">{{item}}</option>
            </select>
          </td>
          <td>
            <select class="form-control form-control-sm" v-model="selectedStatus" required>
              <option value="All" selected>All</option>
              <option v-for="(item, index) in statusFilterSet" :value="item" :key="index">{{item}}</option>
            </select>
          </td>

          <td>
            <select class="form-control form-control-sm" v-model="selectedType" required>
              <option value="All" selected>All</option>
              <option v-for="(item, index) in typeFilterSet" :value="item" :key="index">{{item}}</option>
            </select>
          </td>
          <!-- <td>
            <select class="form-control form-control-sm" v-model="selectedPriority" required>
              <option value="All" selected>All</option>
              <option v-for="(item, index) in priorityFilterSet" :value="item" :key="index">{{item}}</option>
            </select>
          </td> -->
          <td>
            <select class="form-control form-control-sm" v-model="selectedSeverity" required>
              <option value="All" selected>All</option>
              <option v-for="(item, index) in severityFilterSet" :value="item" :key="index">{{item}}</option>
            </select>
          </td>
          <td>
            <!-- <div class="input-group mb-3">
              <input type="text" class="form-control form-control-sm">
              <div class="input-group-append">
                <button class="btn btn-outline-secondary btn-sm" type="button"><i class="fa fa-search"></i></button>
              </div>
            </div> -->
          </td>
          <td>
          </td>
        </tr>
      </thead>
      <tbody>
        <template v-if="filteredList.length">
          <!-- {{hazardListFinal}} -->
          <!-- <template v-for="item in filteredList"> -->
          <!-- <div v-for="item in filteredList" :key="item.objectId"> -->
          <!-- hazardListFinal.length > 0? hazardListFinal:filteredList -->
          <tr v-for="item in hazardListFinal" :key="item.objectId">
            <td>{{item.objectId}}</td>
            <td>{{item.createdBy}}</td>
            <!-- <td>{{item.addressedTo}}</td> -->
            <td>{{item.requestCreated}}</td>
            <!-- <td>{{item.updateBy}}</td> -->
            <!-- <td></td> -->
            <!-- <td>{{item.discipline}}</td> -->
            <td>{{item.hazardType}}</td>
            <td>{{item.approvalStatus}}</td>

            <td>{{item.type}}</td>
            <!-- <td>{{item.priority}}</td> -->
            <td>{{item.severity}}</td>
            <td>
              <template v-if="item.fileId" class="row">
                  <i>
                    <small>
                      {{(item.fileName.length>=attachmentNameLengthLimit?item.fileName.split(".")[0].substring(0,attachmentNameLengthLimit)+'...'+item.fileName.split(".")[item.fileName.split(".").length-1]:item.fileName)}}
                    </small>
                  </i>
                  <button type="button" v-on:click="downloadFile(item.fileId, 'hazardFile')" class="btn btn-light btn-sm mb-xl-2"><i class="fas fa-download"></i></button>
              </template>
            </td>
            <td>
              <a :href="appBaseUrl+item.objectId" v-on:click="goToObject(item.objectId)" target="_blank">
                <button class="btn btn-outline-secondary btn-sm" type="button" ><i class="fa fa-share"></i></button>
              </a>
              <!-- <button type="button" class="btn btn-primary btn-sm mr-2">Request</button>
              <button type="button" class="btn btn-secondary btn-sm">Response</button> -->
            </td>
            <td>
              <b-form-checkbox @change="toggleHazardToDelete(item.objectId)"></b-form-checkbox>
            </td>
          </tr>
          <!-- </div> -->
          <!-- </template> -->
        </template>
        <template v-else>
          <tr>
            <div class="">
              No data found.
            </div>

          </tr>
        </template>

      </tbody>
    </table>
    <div class="row">
      <div class="col-11">
        <paginate
        v-if="filteredList.length > 0"
        v-model="selectedPageNumber"
        :page-count="numberOfPages"
        :page-range="3"
        :margin-pages="2"
        :click-handler="selectNewPage"
        :prev-text="''"
        :next-text="''"
        :container-class="'pagination pagination-sm'"
        :page-class="'page-item'"
        :page-link-class="'page-link'"
        >
        </paginate>
      </div>
      <div class="col-1">
        <b-button variant="outline-danger" :disabled="hazardsToDelete.length==0" v-on:click="deleteHazard"><i class="fa fa-trash-alt"></i></b-button>
      </div>
    </div>
    <button type="button" class="btn btn-secondary btn-circle btn-xl bottomright btn-orange" v-on:click="exportReport()" title="Export Report"><i class="fa fa-download"></i></button>
  </div>
</template>

<script>
/*eslint-disable*/
import { baseApiUrl, appBaseUrl } from "../../config.js"
import axios from "axios"
import Paginate from 'vuejs-paginate'

export default {
  name: 'HazardList',
  components: {
    Paginate
  },
  data() {
    return {
      disciplineFilterSet: ['Design Management','Civil','Road Design','Drainage','Traffic','Utilities','Structures','Geotech','Tunnel','Ventilation','Design & Engineering','GIS','Project Management','Ground Engineering','CAD','ITS Surface','M&E'],
      statusFilterSet: ['Approved','Pending'],
      // typeFilterSet: ['Constructability','Health & Safety','3D Model','Coordination','Design'],
      typeFilterSet: ['Type 1', 'Type 2', 'Type 3', 'Type 4', 'Type 5'],
      // hazardTypeFilterSet: ['Hazard1','Hazard2','Hazard3','Hazard4','Hazard5'],
      // hazardTypeFilterSet: [
      //   // 'Hazard1',
      //   // 'Hazard2',
      //   // 'Hazard3',
      //   // 'Hazard4',
      //   // 'Hazard5'
      //   "01. Straight Platforms",
      //   "02. Curved Platforms",
      //   "03. Buffer Stops",
      //   "04. Train-Platform Collision",
      //   "05. Collision with Southern Services (Metro) Building",
      //   "06. Train Object/Person Collision",
      //   "07. OHW, Power and Electrocution",
      //   "08. Fire and Ventilation",
      //   "09. Spills, Drainage and Flooding",
      //   "10. O&M, Tunnels, Evacutions"
      // ],
      hazardTypeFilterSet: [
        "01. O&M, Tunnels, Evacutions",
        "02. Train-train collision / Scissors",
        "3A. SYAB Angled",
        "3B. SYAB Ground-Level",
        "04. OSD",
        "05. Collision with southern services building",
        "6A. Straight Platform Entry",
        "6B. Straight Platform Midpoint",
        "6C. Straight Platform End",
        "7A. Curved Platform Entry",
        "7B. Curved Platform Midpoint",
        "7C. Curved Platform End",
      ],
      priorityFilterSet: ['Critical', 'Major', 'Minor'],
      severityFilterSet: ['A', 'B', 'C', 'D'],
      selectedStatus: "All",
      selectedDiscipline: "All",
      selectedType: "All",
      selectedHazardType: "All",
      selectedPriority: "All",
      selectedSeverity: "All",
      appBaseUrl: appBaseUrl,
      searchCreatedBy: "",
      searchAddressedTo: "",
      attachmentNameLengthLimit: 15,
      // numberOfPages: 0,
      perPageCount: 10,
      selectedPageNumber: 1,
      hazardsToDelete: []
    }
  },
  computed: {
    hazardList: {
      get() {
        return this.$store.state.mapModule.initialHazards
      }
    },
    filteredList: {
      get() {
        var finalList = this.hazardList
        if (this.selectedDiscipline != "All") {
          finalList = this.hazardList.filter(obj=>obj.discipline == this.selectedDiscipline)
        }
        if (this.selectedStatus != "All") {
          finalList = finalList.filter(obj=>obj.approvalStatus == this.selectedStatus)
        }
        if (this.selectedType != "All") {
          finalList = finalList.filter(obj=>obj.type == this.selectedType)
        }
        if (this.selectedHazardType != "All") {
          finalList = finalList.filter(obj=>obj.hazardType == this.selectedHazardType)
        }
        // if (this.selectedPriority != "All") {
        //   finalList = finalList.filter(obj=>obj.priority == this.selectedPriority)
        // }
        if (this.selectedSeverity != "All") {
          finalList = finalList.filter(obj=>obj.severity == this.selectedSeverity)
        }
        if (this.searchCreatedBy != "") {
          finalList = finalList.filter(list => {
            return list.createdBy.toLowerCase().includes(this.searchCreatedBy.toLowerCase())
          })
        }
        if (this.searchAddressedTo != "") {
          finalList = finalList.filter(list => {
            return list.addressedTo.toLowerCase().includes(this.searchAddressedTo.toLowerCase())
          })
        }
        return finalList
      }
    },
    numberOfPages: {
      get() {
        return Math.ceil(this.filteredList.length / this.perPageCount)
      }
    },
    hazardListFinal: {
      get() {
        // console.log("("+(this.selectedPageNumber - 1) * this.perPageCount+" , "+ this.selectedPageNumber * this.perPageCount +")");
        // console.log(this.numberOfPages);
        // console.log(this.filteredList);
        const current = this
        if(current.numberOfPages >= current.selectedPageNumber){
          return current.filteredList.slice((current.selectedPageNumber - 1) * current.perPageCount, current.selectedPageNumber * current.perPageCount)
        }
        else{
          console.log(current.selectedPageNumber);
          console.log(current.numberOfPages);
          // current.selectedPageNumber = current.numberOfPages
          current.selectedPageNumber = 1
          return current.filteredList.slice((current.selectedPageNumber - 1) * current.perPageCount, current.selectedPageNumber * current.perPageCount)
        }

      }
    }
  },
  methods: {
    goToObject: function(objectId) {
      sessionStorage.origURL = appBaseUrl+objectId
    },
    downloadFile: function(fileId, type) {
      let formData = new FormData();
      let url = baseApiUrl + "downloadAttachment";
      let config = {
        headers: {
          'content-type': 'application/octet-stream'
        },
        responseType: 'blob'
      }
      formData.append("fileId", fileId);
      formData.append("type", type);
      axios.post(url, formData, config).then((result) => {
        var disposition = result.headers['content-disposition'];
        // fix this matches
        var matches = /=(.*)/.exec(disposition);
        var filename = (matches != null && matches[1] ? matches[1] : '').replace(/"*/g,"");
        // filename = filename.replace(/"*/g,"");
        var type = result.headers['content-type'];
        var link = document.createElement('a');

        document.body.appendChild(link)
        link.style = "display: none"
        var blob = new Blob(
          [result.data],
          {type: result.headers['content-type']}
        );
        var url = window.URL.createObjectURL(blob);
        link.href = url;
        link.download = filename;
        link.click();
        window.URL.revokeObjectURL(url);
        // link.remove();
      });
    },
    selectNewPage: function(pageNumber) {
      const current = this
      current.selectedPageNumber = pageNumber
      console.log(pageNumber);
    },
    exportReport: function() {
      let formData = new FormData();
      let url = baseApiUrl + "exportReport";
      let config = {
        headers: {
          'content-type': 'application/octet-stream'
        },
        responseType: 'blob'
      }
      axios.post(url, formData, config).then((result) => {
        var disposition = result.headers['content-disposition'];
        // fix this matches
        var matches = /=(.*)/.exec(disposition);
        var filename = (matches != null && matches[1] ? matches[1] : '').replace(/"*/g,"");
        // filename = filename.replace(/"*/g,"");
        var type = result.headers['content-type'];
        var link = document.createElement('a');

        document.body.appendChild(link)
        link.style = "display: none"
        var blob = new Blob(
          [result.data],
          {type: result.headers['content-type']}
        );
        var url = window.URL.createObjectURL(blob);
        link.href = url;
        link.download = filename;
        link.click();
        window.URL.revokeObjectURL(url);
      });
    },
    deleteHazard: function() {
      // console.log(id);
      const current = this
      var checkDeletion = confirm("Are you sure you would like to delete Hazard(s) #" + current.hazardsToDelete.toString() + " ?")
      if (checkDeletion) {
        console.log(current.hazardsToDelete);
        var data = {
          hazardsToDelete: current.hazardsToDelete
        }
        var url = baseApiUrl + "deleteHazards"
        var config = {
          responseType: 'json'
        }
        axios.post(url, data, config).then(result=>{
          if (result.data.includes('error')) {
            current.$notify({
              group: 'errors',
              title: "Error Deleting Hazards",
              type: 'error',
              text: "Some hazards have problems being deleted. We will refresh the application shortly.",
              width: 500,
              duration: 1000
            })
          }
          else {
            current.$notify({
              group: 'successNotifications',
              title: "Success Deleting Hazards",
              type: 'success',
              text: "Hazard deletion successful. We will refresh the application shortly.",
              width: 500,
              duration: 1000
            })
          }
          setTimeout(function() {
            location.reload()
          }, 1200);
        })
      }
    },
    toggleHazardToDelete: function(id) {
      if (this.hazardsToDelete.includes(id)) {
        const isElementLocation = (element) => element == id;
        var index = this.hazardsToDelete.findIndex(isElementLocation)
        this.hazardsToDelete.splice(index,1)
      }
      else {
        this.hazardsToDelete.push(id)
      }
    }

  },
  aftermount() {
    console.log("after mount");
  }

}
</script>

<style>
.btn-circle.btn-xl {
  width: 70px;
  height: 70px;
  padding: 10px 16px;
  border-radius: 35px;
  font-size: 24px;
  line-height: 1.33;
}

.btn-circle {
  width: 30px;
  height: 30px;
  padding: 6px 0px;
  border-radius: 15px;
  text-align: center;
  font-size: 12px;
  line-height: 1.42857;
}
.bottomright {
  position: absolute;
  bottom: 16px;
  right: 16px;
}

.btn-orange {
  background-color: #E66200 !important;
  border-color: #E66200 !important;
}
.btn-orange:focus {
  -webkit-box-shadow: 0 0 0 0.2rem rgba(230, 98, 0, 0.25) !important;
  box-shadow: 0 0 0 0.2rem rgba(230, 98, 0, 0.25) !important;
}
.page-item.active .page-link {
  color: #fff !important;
  background-color: #E66200 !important;
  border-color: #E66200 !important;
}
.page-link {
  color: #E66200 !important;
}
.page-link:focus {
  -webkit-box-shadow: 0 0 0 0.2rem rgba(230, 98, 0, 0.25) !important;
  box-shadow: 0 0 0 0.2rem rgba(230, 98, 0, 0.25) !important;
}
</style>
